/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Menu/Expanded/DashboardAction/AssignedToMe/Content"
  
}) {
let myTasksCountAggregateCountValueData = fromData.useDataValue({ viewPath,
context: 'my_tasks_count',
path: 'aggregate.count',
})
let constantData = ' assigned to you'
let aggregateData = fromAggregate.join(myTasksCountAggregateCountValueData, constantData)
let myTasksCountAggregateCountValueData1 = fromData.useDataFormat({ viewPath,
context: 'my_tasks_count',
path: 'aggregate.count',
format: fromHelpers.isEmpty,
})
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<fromFlow.When is={myTasksCountAggregateCountValueData1}>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 color={dtColorsNeutral500}
 data="my_tasks_count.aggregate.count"
 data="' assigned to you'"
 aggregate="/Data/aggregate.js join"
 text={aggregateData}
 data="my_tasks_count.aggregate.count"
 format="helpers.js isEmpty"
/>
</fromFlow.When>
{children}
</React.Fragment>)
}